import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import classNames from 'classnames';
import IconLoading from '-!svg-react-loader!../icon-loading.svg';
import IconClose from '-!svg-react-loader!../icon-close.svg';

import Modal from 'react-modal';

const overlayStyle = css`
    position: fixed;
    top:0;
    right:0;
    bottom: 0;
    left: 0;
    background-color: rgba(38,38,38,0.9);
    z-index: 999999999;
    opacity: 0;
    
   transition: opacity .25s ease-in-out;
   -moz-transition: opacity .25s ease-in-out;
   -webkit-transition: opacity .25s ease-in-out;

    &.ReactModal__Overlay--after-open {
        opacity: 1;
    };
    &.ReactModal__Overlay--before-close {
        opacity: 0;
    };
`;

const contentStyle = css`
    position: absolute;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%,-50%);
    overflow: auto;    
    outline: none;
`;

const Container = css`    
    border: 1px solid rgba(204,204,204,1);
    background: rgba(255,255,255,1);
    border-radius: 4px;
    padding: 45px;    
    opacity: 0;

    &.shown{            
        opacity:1;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
`;

const LoadingIcon = styled(IconLoading)`
    position:absolute;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%,-50%);    
`;

const CloseBtn = styled(IconClose)`
    display: block;
    position: absolute;
    right: 20px;
    top: 20px;
    stroke: #b9b9b9;
    cursor: pointer;
`;

class Popup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        };

        this.onAfterOpen = this.onAfterOpen.bind(this);        
    }

    onAfterOpen() {
        this.setState({ isLoading: false });
    }

    componentWillMount() {
        Modal.setAppElement('body');
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen}
                onAfterOpen={this.onAfterOpen}
                onRequestClose={this.props.onRequestClose}
                overlayClassName={overlayStyle}
                className={contentStyle}>    
                {this.state.isLoading &&
                    <LoadingIcon/>
                }                     
                <div className={classNames({[Container]: true, shown : !this.state.isLoading})}>
                    <CloseBtn onClick={this.props.onRequestClose}/>
                    {this.props.children}
                </div>                            
                
            </Modal>
        );
    }
}

Popup.defaultProps = {
    height: 100,
    width: 100
};

Popup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    height: PropTypes.number,
    width: PropTypes.number
};

export default Popup;